import { ViewPortBreakpoint } from "../../../domain/view-port/view-port-breakpoints.js";
import { actions } from "../slice.js";
import { thunkTypes } from "../thunk-types.js";
import { createAsyncThunk } from "@reduxjs/toolkit";
//#region src/redux/view-port/thunks/update-view-port.ts
var updateViewPort = createAsyncThunk(thunkTypes.UPDATE_VIEW_PORT, async (param, { dispatch }) => {
	let breakpoint = ViewPortBreakpoint.DESKTOP;
	if (param.width <= ViewPortBreakpoint.SMARTPHONE) breakpoint = ViewPortBreakpoint.SMARTPHONE;
	if (param.width > ViewPortBreakpoint.SMARTPHONE && param.width <= ViewPortBreakpoint.TABLET) breakpoint = ViewPortBreakpoint.TABLET;
	const viewPort = {
		width: param.width,
		height: param.height,
		breakpoint
	};
	dispatch(actions.updateViewPort({ viewPort }));
	return viewPort;
});
//#endregion
export { updateViewPort };

//# sourceMappingURL=update-view-port.js.map